// Replace a part of a string with a React element.
export function replaceStringWithElement(text, match, replace) {
    const regex = match instanceof RegExp ? match : new RegExp(`(${match})`, 'gi');
    // Apply `replace` to all odd elements
    return text.split(regex).map((entry, index) => (index % 2 ? replace(entry, index) : entry));
}
